import { render, staticRenderFns } from "./ListadoPedidosObsequios.vue?vue&type=template&id=21becf2a&scoped=true"
import script from "./ListadoPedidosObsequios.vue?vue&type=script&lang=js"
export * from "./ListadoPedidosObsequios.vue?vue&type=script&lang=js"
import style0 from "./ListadoPedidosObsequios.vue?vue&type=style&index=0&id=21becf2a&prod&scoped=true&lang=css"
import style1 from "./ListadoPedidosObsequios.vue?vue&type=style&index=1&id=21becf2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21becf2a",
  null
  
)

export default component.exports